// to handle business routing logic
import router from "@/router/index";

export default () => {
  const handleMerchantAllowDirectVisitFlow = async(merchantData) => {
    // api order
    const params = new URLSearchParams(window.location.search);
    if (params.has("id")) {
      return;
    }

    const currentUrl = new URL(window.location);
    const splitUrl = currentUrl.pathname.split('/');
    // Check if the current route is for order status
    if (!merchantData?.allowDirectVisit && splitUrl.includes('status') && splitUrl[splitUrl.length - 1]) {
        return;
    }

    if (merchantData?.allowDirectVisit) {
      return;
    } 

    const supportEmail = "support@banxa.com";
    const { name, returnUrl } = merchantData;
    const errorHtml = `<p>
        To place an order with Banxa on ${name}, please<br />
        visit ${name}'s
        <a href="${returnUrl}" rel="noopener noreferrer">Buy Crypto</a>
        page directly.<br />
      </p>

      <p>
        Do you have any questions?
        <br />
        Our friendly 24/7 support team are always happy to
        <nobr>assist you.</nobr>
        <br />
        Simply reach out to us under:
        <a
          rel="noopener noreferrer"
          style="text-decoration: underline"
          href=mailto:${supportEmail}
          >${supportEmail}</a
        >
      </p>`;

    router.push({
      name: "error",
      query: { status: "dontAllowDirectVisit", text: errorHtml },
    });
  };
  return {
    handleMerchantAllowDirectVisitFlow,
  };
};
